import { DETAIL_MODAL } from 'lib/constants';

import Tipper from 'components/Tipper';
import { zIndex } from 'components/Tipper/Constants';
import PropTypes from 'prop-types';

import { TooltipMain } from './Tooltip.styled';

export const listPlacement = [
	'bottom_start',
	'bottom_end',
	'bottom',
	'top_start',
	'top_end',
	'top',
	'left_start',
	'left_end',
	'left',
	'right_start',
	'right_end',
	'right',
];

export const listThemes = ['WithArrow', 'WithoutArrow'];

export const listTrigger = ['mouseenter', 'click'];

const Tooltip = ({ placement, theme, content, children, trigger, showTooltip, type }) => {
	const tippyProps = (modeTrigger) => {
		const isSafari = !!/^((?!chrome|android).)*safari/i.exec(navigator.userAgent);
		const iOS = /iPad|iPhone|iPod/.exec(navigator.userAgent) && !window.MSStream;

		const conf = {
			interactive: true,
			animation: 'scale',
			offset: [0, 13],
			appendTo: document.body,
			maxWidth: 250,
			trigger: modeTrigger,
			delay: [100, 100],
			className: (isSafari || iOS) && placement != 'bottom_start' ? 'additional-translate' : '',
			zIndex: type != DETAIL_MODAL ? zIndex.searchCard : zIndex.detailModal,
		};

		return conf;
	};

	return (
		<TooltipMain>
			<Tipper placement={placement} content={content} configuration={tippyProps(trigger)} type="tooltip" theme={theme} disabled={!showTooltip}>
				<span>{children}</span>
			</Tipper>
		</TooltipMain>
	);
};

Tooltip.propTypes = {
	/** Placement, place where is showing the tooltip */
	placement: PropTypes.oneOf(listPlacement).isRequired,
	/** Theme, On/off the Arrow */
	theme: PropTypes.oneOf(listThemes).isRequired,
	/** Content, Component is inside in the body of Tooltip */
	content: PropTypes.oneOfType([PropTypes.element, PropTypes.string, PropTypes.elementType]).isRequired,
	/** Children, Component trigger the Tooltip */
	children: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
	trigger: PropTypes.oneOf(listTrigger),
	showTooltip: PropTypes.bool,
	type: PropTypes.string,
};

Tooltip.defaultProps = {
	children: '',
	trigger: 'mouseenter',
	showTooltip: true,
};

export default Tooltip;
